import { useContext } from 'react';

import { ConsentContext } from '../context/ConsentContext';

export const useConsent = () => {
    const ctx = useContext(ConsentContext);

    if (!ctx) {
        throw new Error('useConsent must be used within a ConsentProvider');
    }

    return {
        necessary: ctx.state.necessary,
        functional: ctx.state.functional,
        analytics: ctx.state.analytics,
        marketing: ctx.state.marketing,
        isReady: ctx.isReady,
        openPreferences: ctx.openPreferences,
    };
};
